import styled from 'styled-components';
export var ActionsBlock = styled.div.withConfig({
  displayName: "partials__ActionsBlock",
  componentId: "sc-1xz2c7o-0"
})(["display:flex;justify-content:space-between;width:100%;padding:5px 0;"]);